import QuillDelta from 'quill-delta';
import { Box } from 'reflexbox';
import { useField } from 'formik';

import * as graphql from 'generated/graphql';
import useLocalize from 'packages/kakapo-ui-application/hooks/useLocalize';
import Text from 'packages/kakapo-ui-kit/components/common/Paragraph';
import QuillEditor from 'packages/kakapo-ui-kit/components/editors/QuillEditor';
import QuillText from 'packages/kakapo-ui-kit/components/editors/QuillText';
import { useTranslation } from 'react-i18next';

export default function OpenQuestion(props: {
	name: string;
	item: graphql.EvaluationOpenQuestionItem;
	readonly?: boolean;
}) {
	const { localize } = useLocalize();

	const [field, , { setValue }] = useField<QuillDelta>(props.name + '.openQuestion');
	const value = field.value ?? new QuillDelta({ ops: [] });

	const { t } = useTranslation();

	return (
		<>
			<Text color="slateBlue" style={{ maxWidth: 600 }}>
				{localize(props.item.title).text}
			</Text>
			<Box mt={3}>
				{props.readonly ? (
					<QuillText quill={value} placeholder={t('evaluation.submission.openQuestion.empty')} />
				) : (
					<QuillEditor boxedStyling value={value} onChange={setValue} />
				)}
			</Box>
		</>
	);
}
